import { createContext } from 'react';

import { SmartbotAIConnectionStore } from './SmartbotAIConnectionStore';

const SmartbotAIConnectionStoreContext = createContext<{
  store: SmartbotAIConnectionStore | null;
}>({
  store: null
});

const SmartbotAIConnectionStoreProvider =
  SmartbotAIConnectionStoreContext.Provider;

export { SmartbotAIConnectionStoreContext, SmartbotAIConnectionStoreProvider };
